<template>
  <lateral-modal @close="closeModal">
    <template slot="extraAction">
      <div class="d-flex toolbar-column dropdown--container">
        <button class="Fuell-CreditCard--actions-button Fuell-Dropdown--button-dots">
          <img
            alt="dot-icon-menu"
            :src="require('@/assets/img/icons/icon-dots.svg')"
          />
        </button>
        <ul class="dropdown--content">
          <li
            class="clickable"
            @click="showDownloadModal"
          >
            <span
              class="Fuell-ToolbarButton--label"
              v-t="{ path: 'transactions_action_download' }"
            >
            </span>
          </li>
        </ul>
      </div>
    </template>
    <template slot="content">
      <div
        class="px-2"
        ref="modalbox"
      >
        <div class="d-flex justify-content-center align-items-center mb-4">
          <card-item
            @checkPasscode="checkPasscode"
            :card="card"
            :active="true"
          ></card-item>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <ul class="Tabs mt-2 d-flex">
              <li class="Tabs-itm flex-grow-1">
                <a
                  class="Tabs-itmLink"
                  :class="{
                    'Tabs-itmLink--curr':
                      overviewTabShownFlag && !transactionsTabShownFlag
                  }"
                  href="#"
                  @click.prevent="showOverviewTab"
                  ata-show="tabs1"
                  data-cont="overview"
                  v-t.preserve="{ path: 'card_detail_modal_overview' }"
                ></a>
              </li>
              <li class="Tabs-itm flex-grow-1">
                <a
                  class="Tabs-itmLink"
                  :class="{
                    'Tabs-itmLink--curr':
                      !overviewTabShownFlag && transactionsTabShownFlag
                  }"
                  href="#"
                  data-show="tabs1"
                  @click.prevent="showTransactionsTab"
                  data-cont="transactions"
                  v-t.preserve="{ path: 'card_detail_modal_transactions' }"
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div id="tabs1">
          <card-detail-overview
            :card.sync="card"
            v-if="overviewTabShownFlag && !transactionsTabShownFlag"
          ></card-detail-overview>
          <card-detail-transactions
            :cardId="this.card.id"
            @showTransactionDetail="showTransactionDetail"
            v-if="!overviewTabShownFlag && transactionsTabShownFlag"
          ></card-detail-transactions>
        </div>
        <div class="d-flex justify-content-center">
          <spinner v-if="isLoadingTransactions"></spinner>
        </div>
      </div>
    </template>
  </lateral-modal>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import CardItem from './CardItem'
import CardDetailOverview from './CardDetailOverview'
import CardDetailTransactions from './CardDetailTransactions'
import Spinner from '@/components/Commons/Spinner'
import LateralModal from '@/components/Commons/Modals/LateralModal'

export default {
  name: 'CardDetailModal',
  mixins: [_modalHandlerMixin],
  components: { CardItem, CardDetailOverview, CardDetailTransactions, Spinner, LateralModal },
  data () {
    return {
      overviewTabShownFlag: false,
      transactionsTabShownFlag: true,
      showTransactionDownloadModalFlag: false,
      extraFilters: {
        exportTypeCode: 'DOWNLOAD'
      }
    }
  },
  props: {
    cardId: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    card () {
      return this.$store.getters['CardsStore/cards'].find(
        el => el.id === this.cardId
      )
    },
    cardTransactions () {
      return this.$store.getters['TransactionsStore/transactions'] || []
    },
    currentPage () {
      return this.$store.getters['TransactionsStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['TransactionsStore/lastPage']
    },
    isLoadingTransactions () {
      return this.$store.getters['TransactionsStore/isLoadingTransactions']
    }
  },
  methods: {
    showOverviewTab () {
      this.overviewTabShownFlag = true
      this.transactionsTabShownFlag = false
    },
    showTransactionsTab () {
      this.overviewTabShownFlag = false
      this.transactionsTabShownFlag = true
    },
    nextPage () {
      this.$store.dispatch('TransactionsStore/nextTransactionsPage')
    },
    pageHandler () {
      const modal = this.$refs.modalbox
      modal.onscroll = () => {
        let bottom = modal.scrollHeight - modal.scrollTop === modal.offsetHeight
        if (bottom && this.currentPage < this.lastPage) {
          this.nextPage()
        }
      }
    },
    checkPasscode (event) {
      this.$emit('checkPasscode', event)
    },
    showTransactionDetail (event) {
      this.$emit('showTransactionDetail', event)
    },
    async fetchTransactions () {
      const filters = {
        'card.id': this.card.id,
        'status.code': ['OK', 'PENDING'],
        'amountDistinctZero': true
      }
      try {
        await this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
          filters: filters
        })
      } catch (error) {
        this.$store.dispatch('TransactionsStore/addErrorHandler', { error: error, errorMessage: 'transactions_fetch_transactions_error' })
      }
    },
    showDownloadModal () {
      const filters = {
        'card.id': this.card.id,
        'status.code': ['OK', 'PENDING'],
        'amountDistinctZero': true,
        downloadTypeCode: this.card.type.code === 'MEMBER_PHYSICAL' ? 'PHYSICAL_CARDS' : 'VIRTUAL_CARDS'
      }
      try {
        this.extraFilters = { ...this.extraFilters, ...filters }
        this.$emit('showDownloadModal', this.extraFilters)
      } catch (error) {
        this.$store.dispatch('TransactionsStore/addErrorHandler', { error: error, errorMessage: 'transactions_fetch_transactions_error' })
      }
    }
  },
  mounted () {
    this.pageHandler()
  },
  destroyed () {
    this.$store.dispatch('TransactionsStore/clearStore')
  },
  watch: {
    cardId: async function (newV) {
      this.overviewTabShownFlag = false
      this.transactionsTabShownFlag = true
      this.$store.dispatch('TransactionsStore/clearStore')
      await this.fetchTransactions()
    },
    transactionsTabShownFlag: async function (newV) {
      if (newV) {
        await this.fetchTransactions()
      }
    }
  }
}
</script>
<style lang="scss" src="@/assets/styles/dropdown/dropdowns.scss" scoped></style>
<style scoped>
.Fuell-CreditCard--actions-button {
  position: initial;
  margin-right: 24px;
}
.dropdown--content {
  top: 24px;
}
@media screen and (min-width: 992px) {
  .ModalBox {
    width: 550px;
  }
}
</style>
